<template>
  <div class="list-header">
    <!-- <van-nav-bar
      title="订单查询"
      left-arrow
      fixed
      @click-left="onClickLeft"
      class="pullRefresh-header"
      ref="pullRefresh"
    /> -->
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      class="scrolldivmain"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="order-header-list"
          v-for="(item, index) in orderList"
          :key="index"
        >
          <div class="order-info">
              <div class="num">
                <span class="content-left ">订单号：</span>
                <span class="content-order">{{ item.sourceOrderSn }}</span>
              </div>
              <div class="num">
                <span class="content-left">手机号：</span>
                <span class="content-order">{{ item.receiverMobile }}</span>
              </div>
            <div
              class="num logistics-num"
              v-for="(element, itemIndex) in item.logisticsList"
              :key="itemIndex" 
              @click="
                    handleClick(
                      element.logisticsTraces,
                      element.logisticsCode,
                      element.logisticsType,
                      item.sourceOrderSn
                    )
                  "
            >
              <div class="num-left">
                 <div class="num">
                  <span class="content-left split">物流名称：</span>
                  <span v-if="element.logisticsCode" class="content-order" :class="element.logisticsCode ? '' : 'logistics-info'" >
                    {{ element.logisticsType | codeToName }}
                  </span>
                 </div>
                 <div class="num">
                  <span class="content-left split">物流单号：</span>
                  <span :class="element.logisticsCode ? '' : 'logistics-info'" class="content-right">
                    {{
                      element.logisticsCode ? element.logisticsCode : "暂未发货"
                    }}
                  </span>
                 </div>
              </div>
              <div class="num-right" v-if="element.logisticsCode">
                <span
                  class="good-details"
                  >走件详情
                </span>
              </div>
            </div>
            <div
              class="num num-left"
              v-if="!item.logisticsList.length || !item.logisticsList"
            >
              <span class="content-left split">物流名称：</span>
            </div>
            <div
              class="num"
              v-if="!item.logisticsList.length || !item.logisticsList"
            >
              <span class="content-left split">物流单号：</span>
              <span class="logistics-info">暂未发货</span>
            </div>
            <!-- 多包裹 -->
            <img
              src="../../assets/more.png"
              class="parcel-img"
              v-if="item.logisticsList.length > 1"
            />
          </div>
        </div>
      </van-list>

      <van-empty
        v-if="!orderList.length"
        description="没有查询到相关数据"
        :image="emptyImage"
      />
    </van-pull-refresh>
  </div>
</template>

<script>
import { Toast } from "vant";
import mock from '../../api/http/mock'

export default {
  data() {
    return {
      // 订单查询 list
      orderList: [],
      loading: true,
      finished: false,
      scrollTop: 0,
      params: null,
      refreshing: false,
      // 空状态图片
      emptyImage: require("../../assets/empty.png")
    };
  },

  created() {
    this.onLoad();
  },

  activated() {
    this.params = this.$route.query.data;
    const scrollDivMain = document.querySelector(".scrolldivmain");
    scrollDivMain.scrollTop = this.scrollTop;
    this.onLoad();
  },

  methods: {
    onLoad() {
      if (this.refreshing) {
        this.orderList = [];
        this.refreshing = false;
      }
      // 加载状态结束
      this.loading = false;
      this.$httpUtil(`logistics/list?text=${this.params}`, {}).then(res => {
        this.orderList = res && res.data;
        // this.orderList = mock.data
      });

      // 数据全部加载完成
      if (this.orderList.length >= 2) {
        this.finished = true;
      }
    },

    // 清空列表数据
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      this.loading = true;
      this.onLoad();
    },

    // 走件详情
    handleClick(list, code, type,sourceOrderSn) {
      const scrollDivMain = document.querySelector(".scrolldivmain");
      this.$nextTick(() => {
        this.scrollTop = scrollDivMain.scrollTop;
      });

      this.$router.push({
        path: "/logisticsQuery",
        query: {
          data: {
            list,
            code,
            type,
            sourceOrderSn
          }
        }
      });
    },

    // 返回功能
    // onClickLeft() {
    //   this.$router.go(-1);
    // }
  }
};
</script>

<style scoped>
.num-left{
  border-top:1px solid #EAEAEA;
    padding-top: 20px;
}
.list-header {
  /* padding-top: 10px; */
  box-sizing: border-box;
  height: 100%;
  background:rgba(248,248,248,1);
}

.van-nav-bar__title {
  color: #333;
  font-size: 17px;
}

/deep/ .van-nav-bar .van-icon {
  color: #666;
  font-size: 22px;
}

/deep/ .van-nav-bar__title {
  font-size: 17px;
  font-weight: 505;
}

.van-pull-refresh {
  /* overflow-y: auto; */
  /* height: 100%; */
  /* margin-top: 46px; */
}

.order-header-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 24px 0 0 13px;
  font-size: 14px;
  border-bottom: 1px solid #ebebeb;
  background: #fff;
  margin-top: 10px;
}

.van-list {
  width: 100%;
}

.van-empty {
  height: 100%;
      padding-top: 50%;
}

.order-info>div{
  font-size:0;
}

.parcel-img {
  position: absolute;
  top: 0px;
  right: 0px;
  width:46px;
  height:49px;
}

.num {
  padding-bottom: 10px;
  text-align: left;
} 
 




.content-left,.content-middle,.content-right,.content-order{
font-size:14px;
  display: inline-block;
}

.content-left {
  width:25%;
  text-align: right;
  color: #666;
}

.content-middle{
  width:18%;
}

.content-right{
  width:40%;
}

.content-order {
  width:75%;
  text-align: left;
  color: #333;
}

.logistics-num {
  position: relative;
}

.num-right {
  position: absolute;
  right: 12px;
  bottom: 22px;
}

.logistics-info {
  font-size:14px;
  color: #ed1a1a;
}

.good-details {
  color: #f77403;
  font-size: 12px;
   background-image: url('../../assets/arrow.png');
  background-size:contain;
  background-repeat:no-repeat;
  background-position: right center;
  padding-right: 20px;
}

/deep/ .van-empty__image {
  width: 80.5px;
  height: 75px;
}

/deep/ .van-empty__description {
  color: #333333;
}
</style>
